import { BackendServiceUrl, BaseService } from './BaseService';

/**
 * Client for the /announcements API (#1618). Endpoints return either a list of
 * eligible ids (GET /eligible) or 204 (POST seen/expanded/snooze/impression).
 */
export class AnnouncementsService extends BaseService {
    constructor(accessToken: string, baseServiceUrl: string = BackendServiceUrl) {
        super(accessToken, baseServiceUrl);
    }

    public async getEligibleAsync(): Promise<string[]> {
        return await this.getResponseAsync<string[]>({
            commandPath: 'announcements/eligible',
            method: 'GET',
        });
    }

    public async markSeenAsync(id: string): Promise<void> {
        await this.getResponseAsync<unknown>({
            commandPath: `announcements/${encodeURIComponent(id)}/seen`,
            method: 'POST',
        });
    }

    public async markExpandedAsync(id: string): Promise<void> {
        await this.getResponseAsync<unknown>({
            commandPath: `announcements/${encodeURIComponent(id)}/expanded`,
            method: 'POST',
        });
    }

    public async markSnoozedAsync(id: string): Promise<void> {
        await this.getResponseAsync<unknown>({
            commandPath: `announcements/${encodeURIComponent(id)}/snooze`,
            method: 'POST',
        });
    }

    public async registerImpressionAsync(id: string): Promise<void> {
        await this.getResponseAsync<unknown>({
            commandPath: `announcements/${encodeURIComponent(id)}/impression`,
            method: 'POST',
        });
    }
}
